import React from 'react';
import { Flame } from 'lucide-react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 w-full bg-red-600 text-white py-2.5 px-4 text-center text-sm md:text-base font-bold flex items-center justify-center shadow-lg" data-id="element-253">
      <Flame className="w-4 h-4 text-white mr-2 animate-pulse" data-id="element-254" />
      <span className="font-extrabold tracking-wide" data-id="element-255">
        70% OFF + 4 BONUS SOLO POR HOY
      </span>
      <Flame className="w-4 h-4 text-white ml-2 animate-pulse" data-id="element-256" />
    </div>;
}